import { useEffect } from "react";
import AdminModal from "./AdminModal";
import { adminCancelButtonClass, adminDangerButtonClass } from "./adminStyles";

const ConfirmDeleteModal = ({
  open,
  title,
  message,
  deleting,
  onCancel,
  onConfirm,
  confirmLabel = "Yes, Delete",
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Enter") { e.preventDefault(); onConfirm(); }
      if (e.key === "Escape") { e.preventDefault(); onCancel(); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onConfirm, onCancel]);

  if (!open) return null;

  return (
    <AdminModal title={title} onClose={onCancel}>
      <div className="mb-5 rounded-lg border border-red-100 bg-red-50 px-4 py-3">
        <p className="text-sm text-red-700">{message}</p>
      </div>
      <p className="mb-3 text-[10px] text-gray-400">Enter to confirm · Esc to cancel</p>
      <div className="flex gap-2">
        <button onClick={onCancel} className={adminCancelButtonClass}>
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={deleting}
          className={adminDangerButtonClass}
        >
          {deleting ? "Deleting..." : confirmLabel}
        </button>
      </div>
    </AdminModal>
  );
};

export default ConfirmDeleteModal;